import { Button, CircularProgress, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { AuthComp } from "../../../auth/AuthComp";
import { Redirect } from "../../tools/Redirect";
import { ADESIONECL, LOGIN, RIFIUTOCL, STRUTTURE } from "../../../global/urlMapping";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { profiloAriannaSelector } from "../../../modules/screening/selectors";
import Barcode from "react-barcode";
import { switchInviteDesc, switchWithdrawalMethod } from "../../../api/apiAdaptation";

export const DettaglioInvitoSollecitoCL = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const profiloArianna = useSelector(profiloAriannaSelector)
    const [paperAdesione, setPaperAdesione] = useState(false)
    const [paperModifica, setPaperModifica] = useState(false)
    const [buttonNonAderisco, setButtonNonAderisco] = useState(false)
    const [buttonModifica, setButtonModifica] = useState(false)
    const [buttonDeclina, setButtonDeclina] = useState(false)

    const [buttonConsultaCentriDiRitiro, setButtonConsultaCentriDiRitiro] = useState(false)

    //per mockare
    /*const invite = {
        type: "SCREENING_CENTER_INVITE",
        status: "DECLINED",
        statusDesc: "INVITATO",
        withdrawalMethod: "COLLECTION_CENTER",
        id: "1",
        inviteDesc: "Servizio screening"
    };*/


    const getNomeUtente = () => {
        return profiloArianna?.value?.patient?.patientGivenName
    }
    const invite = location?.state?.element
    const isHidden = invite === undefined || invite === null;
    useEffect(() => {
        switch (invite?.status) {
            case "INVITED":
                if (invite?.type === "SCREENING_CENTER_INVITE" || invite?.type === "REMINDER") {
                    setPaperAdesione(true)
                    setButtonNonAderisco(true)
                    setPaperModifica(false)
                    setButtonModifica(false)
                    setButtonDeclina(false)
                }
                else if (invite?.type === "INVITE") {
                    setPaperAdesione(false)
                    setButtonNonAderisco(false)
                    setPaperModifica(true)
                    setButtonModifica(true)
                    setButtonDeclina(true)
                }
                break;
            case "CONFIRMED":
                setPaperAdesione(false)
                setButtonNonAderisco(false)
                setPaperModifica(true)
                setButtonModifica(true)
                setButtonDeclina(true)
                break;
            case "SHIPPED":
                setPaperAdesione(false)
                setButtonNonAderisco(false)
                setPaperModifica(true)
                setButtonModifica(false)
                setButtonDeclina(false)
                break;
            case "WITHDRAWN":
                setPaperAdesione(false)
                setButtonNonAderisco(false)
                setPaperModifica(true)
                setButtonModifica(false)
                setButtonDeclina(false)
                break;
            case "RETURNED":
                setPaperAdesione(false)
                setButtonNonAderisco(false)
                setPaperModifica(true)
                setButtonModifica(false)
                setButtonDeclina(false)
                break;
            case "DECLINED":
                setPaperAdesione(true)
                setButtonNonAderisco(false)
                setPaperModifica(false)
                setButtonModifica(false)
                setButtonDeclina(false)
                break;
            case "DECLINED_PERM":
                setPaperAdesione(false)
                setButtonNonAderisco(false)
                setPaperModifica(true)
                setButtonModifica(false)
                setButtonDeclina(false)
                break;
            default:
                break;
        }
        if (invite?.withdrawalMethod === "COLLECTION_CENTER" && invite?.status !== "WITHDRAWN" && paperModifica)
            setButtonConsultaCentriDiRitiro(true)
        else
            setButtonConsultaCentriDiRitiro(false)

    }, [invite, buttonConsultaCentriDiRitiro, paperModifica])




    useEffect(() => {
        if (isHidden)
            navigate(-1)
    }, [isHidden, navigate])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <AuthComp fallback={<Redirect link={LOGIN} />}>
            {
                !isHidden &&
                <Box className="bg" sx={{ paddingBottom: "50px" }}>
                    < Box
                        sx={{
                            backgroundColor: "transparent",
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            minWidth: "280px",
                        }}
                    >
                        {
                            paperAdesione &&
                            <>
                                <Box
                                    sx={{
                                        minHeight: { xs: "calc(100vh - (600px + 200px)", md: "calc(100vh - (250px + 200px)" },
                                        backgroundColor: "transparent",
                                        width: { md: "100%", xs: "60%" },
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <Typography
                                        component="h1"
                                        sx={{
                                            color: "#005397",
                                            fontSize: { xs: "35px", md: "45px" },
                                            fontWeight: 700,
                                            margin: "20px auto",
                                            textAlign: "center",
                                            width: "60%",
                                            wordWrap: "break-word",
                                        }}
                                    >
                                        Buongiorno {getNomeUtente()}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            backgroundColor: "transparent",
                                            color: "#005397",
                                            fontSize: { xs: "20px", md: "35px" },
                                            fontWeight: 400,
                                            margin: "0 auto",
                                            textAlign: "center",
                                            width: { xs: "80%", md: "60%" },
                                            wordWrap: "break-word",
                                        }}
                                    >
                                        Partecipa alla campagna di screening Colon Retto.
                                    </Typography>
                                    <Typography
                                        sx={{
                                            backgroundColor: "transparent",
                                            color: "#005397",
                                            fontSize: { xs: "20px", md: "35px" },
                                            fontWeight: 400,
                                            margin: "0 auto",
                                            textAlign: "center",
                                            width: { xs: "80%", md: "60%" },
                                            wordWrap: "break-word",
                                        }}
                                    >
                                        Il metodo più efficace per la prevenzione a portata di click!
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        minHeight: "calc (100% - 200px)",
                                        backgroundColor: "transparent",
                                        display: "flex",
                                        flexDirection: "column",
                                        marginTop: "20px",
                                        width: "100%",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#005397",
                                            fontSize: { xs: "25px", md: "30px" },
                                            fontWeight: 550,
                                            textAlign: "center",
                                            margin: "auto",
                                        }}
                                    >
                                        Vuoi aderire alla campagna di Screening Colon Retto?
                                    </Typography>
                                    <Box sx={{ height: "200px", width: { md: "100%", xs: "80%" }, display: "flex", flexDirection: "column", margin: "auto", }}>
                                        <Button
                                            disableRipple
                                            disableTouchRipple
                                            disableFocusRipple
                                            sx={{
                                                height: "50px",
                                                borderRadius: "20px !important",
                                                width: { md: "250px", xs: "50%" },
                                                margin: "30px auto",
                                                backgroundColor: "#005397 !important",
                                            }}
                                            onClick={() => { navigate(ADESIONECL, { state: { invite } }); }}
                                        >
                                            <Typography sx={{ color: "white", fontSize: "18px", fontWeight: 600, textAlign: "center" }}>
                                                {"Sì, aderisco"}
                                            </Typography>
                                        </Button>
                                        <Button
                                            variant="contained"
                                            disabled={!buttonNonAderisco}
                                            disableRipple
                                            disableTouchRipple
                                            disableFocusRipple
                                            sx={{
                                                height: "50px",
                                                borderRadius: "20px !important",
                                                border: "1px solid #005397",
                                                width: { md: "250px", xs: "50%" },
                                                margin: "0 auto",
                                                backgroundColor: "white !important",
                                            }}
                                            onClick={() => { navigate(RIFIUTOCL, { state: { invite } }); }}
                                        >
                                            <Typography sx={{ color: buttonNonAderisco ? "#005397" : "#A0B4C3", fontSize: "18px", fontWeight: 600, textAlign: "center" }}>
                                                No, non aderisco
                                            </Typography>
                                        </Button>
                                    </Box>
                                </Box>
                            </>
                        }
                        {
                            !paperAdesione && paperModifica &&
                            <Box
                                sx={{
                                    backgroundColor: "transparent",
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <Typography
                                    component="h1"
                                    sx={{
                                        color: "#005397",
                                        fontSize: { xs: "35px", md: "45px" },
                                        fontWeight: 700,
                                        margin: "20px auto",
                                        textAlign: "center",
                                        width: "60%",
                                        wordWrap: "break-word",
                                    }}
                                >
                                    Di seguito i dettagli dell'invito
                                </Typography>

                                <Typography
                                    sx={{
                                        backgroundColor: "transparent",
                                        color: "#005397",
                                        fontSize: { xs: "20px", md: "35px" },
                                        fontWeight: 400,
                                        margin: "0 auto",
                                        textAlign: "center",
                                        width: { xs: "80%", md: "60%" },
                                        wordWrap: "break-word",
                                        marginBottom: "20px"
                                    }}
                                >
                                    Visualizza i dettagli dell'invito o modifica come ricevere il kit
                                </Typography>
                            </Box>
                        }
                        <Paper key={invite?.id} elevation={5}
                            sx={{
                                maxWidth: '100%',
                                textDecoration: "none",
                                backgroundColor: 'white',
                                borderRadius: '20px',
                                margin: 'auto',
                                padding: '4vh',
                                display: 'flex',
                                flexDirection: 'column',
                                mb: "10px",
                                textAlign: "center",
                            }}>
                            <Box sx={{ backgroundColor: 'transparent' }}>
                                <Typography sx={{ margin: '10px auto', color: '#005397', fontSize: '20px', textAlign: 'center', fontWeight: 500 }}>
                                    {switchInviteDesc(invite)}
                                </Typography>
                                <Barcode value={profiloArianna?.value?.patient?.id ?? ""} />
                                {
                                    paperModifica &&
                                    <Typography sx={{ margin: '10px auto', color: '#005397', fontSize: '20px', textAlign: 'center', fontWeight: 500 }}>
                                        Metodo di ritiro: {switchWithdrawalMethod(invite?.withdrawalMethod)}
                                    </Typography>
                                }
                                <Box sx={{ margin: '10px auto', color: ((invite?.status === "INVITED" && invite?.type === "REMINDER") || invite?.status === "DECLINED" || invite?.status === "DECLINED_PERM") ? "red" : "green", fontSize: '25px', textAlign: 'center', fontWeight: 700 }}>
                                    {invite?.statusDesc}
                                    {
                                        buttonConsultaCentriDiRitiro &&
                                        < Button
                                            component={Link}
                                            to={STRUTTURE}
                                            disabled={invite?.withdrawalMethod === "SHIPPED"}
                                            disableRipple
                                            disableTouchRipple
                                            disableFocusRipple
                                            sx={{
                                                height: "50px",
                                                borderRadius: "50px !important",
                                                width: { xs: '80%', md: '80%' },
                                                margin: "30px auto",
                                                backgroundColor: "#005397 !important",
                                                "&.Mui-disabled": {
                                                    backgroundColor: "#81AFD7 !important",
                                                }
                                            }}
                                        >
                                            <Typography sx={{ color: "white", fontSize: { md: "18px", xs: "14px" }, fontWeight: 600, textAlign: "center" }}>
                                                Consulta i centri di ritiro
                                            </Typography>
                                        </Button>}
                                </Box>
                            </Box>
                        </Paper>
                        {
                            paperModifica &&
                            <>
                                < Button
                                    disabled={!buttonModifica}
                                    disableRipple
                                    disableTouchRipple
                                    disableFocusRipple
                                    sx={{
                                        height: "50px",
                                        borderRadius: "20px !important",
                                        width: { xs: '60%', md: '450px' },
                                        margin: "30px auto",
                                        backgroundColor: "#005397 !important",
                                        "&.Mui-disabled": {
                                            backgroundColor: "#81AFD7 !important",
                                        }
                                    }}
                                    onClick={() => { navigate(ADESIONECL, { state: { invite } }); }}
                                >
                                    <Typography sx={{ color: "white", fontSize: "18px", fontWeight: 600, textAlign: "center" }}>
                                        Modifica
                                    </Typography>
                                </Button>
                                <Button
                                    variant="contained"
                                    disabled={!buttonDeclina}
                                    disableRipple
                                    disableTouchRipple
                                    disableFocusRipple
                                    sx={{
                                        height: "50px",
                                        borderRadius: "20px !important",
                                        border: "1px solid #005397",
                                        width: { xs: '60%', md: '450px' },
                                        margin: "0 auto",
                                        backgroundColor: "white !important",
                                        "&.Mui-disabled": {
                                            border: "1px solid #A0B4C3 !important",
                                        },
                                    }}
                                    onClick={() => { navigate(RIFIUTOCL, { state: { invite } }); }}
                                >
                                    <Typography sx={{
                                        color: buttonDeclina ? "#005397" : "#A0B4C3", fontSize: "18px", fontWeight: 600, textAlign: "center"
                                    }}>
                                        Declina
                                    </Typography>
                                </Button>
                            </>
                        }
                    </Box>
                </Box>
            }
            {
                isHidden && <CircularProgress sx={{ margin: "10% auto", display: 'flex', alignItems: "center" }} />
            }
        </AuthComp >
    );
}